import { Navigate, Route, Routes } from 'react-router-dom';
import ManageMsisdn from './MsisdnPage';
import GeofencesPage from './GeofencePage/GeofencesPage';
import DashboardMsisdnPage from './DashboardMsisdnsPage';
import AuthGuard from '../components/Auth/AuthGuard';
import { useAuth0 } from '@auth0/auth0-react';
import PageLoader from '../components/PageLoader';
import UsersPage from './UsersPage';
import CompaniesPage from "./CompaniesPage";
import useImpersonation from "../Hooks/useImpersonation";
import SettingsPage from "./SettingsPage/SettingsPage";
import useCompanyId from "../Hooks/useCompanyId";
import BrowseWorkOrdersPage from "./WorkOrdersPage/BrowseWorkOrdersPage";
import WorkOrderPage from "./WorkOrdersPage/WorkOrderPage";
import HoursPage from "./HoursPage/HoursPage";
import PdfHoursExport from "../components/core/Pdf/PdfHoursExport";
import useCompany from "../Hooks/useCompany";
import GlobalSettingsPage from "./GlobalSettingsPage";
import TimelineEventsPage from "./TimelineEventsPage";
import CreditManagementPage from './CreditManagementPage';
import TrialPage from './TrialPage';

import { useContext } from "react";
import { SalvoContext } from "../contexts/SalvoContext";

export default function AppRoutes() {
    const { isLoading: auth0Loading } = useAuth0()
    const { isImpersonating, canImpersonate } = useImpersonation()

    const companyId = useCompanyId()
    const company = useCompany()
    const { companyError, retryFetchCompany } = useContext(SalvoContext)

    if (!company && companyError)
        return (
            <div className='mt-5 text-center'>
                <p>Loading the company data failed.</p>
                <button className='btn btn-primary' onClick={retryFetchCompany}>
                    Try again
                </button>
            </div>
        )

    if (auth0Loading || !companyId || !company)
        return <PageLoader className='mt-5' text='Loading' />

    if (canImpersonate && !isImpersonating) {
        return (
            <Routes>
                <Route path='companies' element={<AuthGuard component={CompaniesPage} />} />
                <Route path='settings' element={<AuthGuard component={GlobalSettingsPage} />} />
                <Route path='*' element={<Navigate to={'/companies'} replace />} />
            </Routes>
        )
    }

    return (
        <Routes>
            <Route path='geofences' element={<AuthGuard component={GeofencesPage} />} />
            <Route path='dashboard' element={<AuthGuard component={DashboardMsisdnPage} />} />
            <Route path='msisdns' element={<AuthGuard component={ManageMsisdn} />} />
            <Route path='workorders' element={<AuthGuard component={BrowseWorkOrdersPage} />} />
            <Route path='workorders/:workOrderId' element={<AuthGuard component={WorkOrderPage} />} />
            <Route path='hours' element={<AuthGuard component={HoursPage} />} />
            <Route path='hours/week' element={<AuthGuard component={HoursPage} periodSelector={'week'} />} />
            <Route path='hours/export' element={<PdfHoursExport />} />
            <Route path='users/:companyId' element={<AuthGuard component={UsersPage} />} />
            <Route path='settings' element={<AuthGuard component={SettingsPage} />} />
            <Route path='billing' element={<AuthGuard component={CreditManagementPage} />} />
            <Route path='trial' element={<AuthGuard component={TrialPage} />} />
            <Route path='timeline/events' element={<AuthGuard component={TimelineEventsPage} />} />
            <Route path='callback' element={<PageLoader />} />
            <Route path='*' element={<Navigate to={'/dashboard'} replace />} /> {/* This is the default route */}
        </Routes>
    )
}

